<page-heading
  [title]="'task.form.pageTitle' | translate"
  [description]="
    isNew ? ('task.form.pageDescriptionNew' | translate) : ('task.form.pageDescriptionEdit' | translate)
  "
  [hasBreadcrumb]="true"
  [breadcrumb]="breadcrumb"
/>

<form [formGroup]="formGroup">
  <div class="row g-2">
    <div class="col-xs-12 col-lg-7">
      <div class="card">
        <div class="card-body gap-3">
          <div class="row">
            <div class="col-xs-12 col-md-8 mb-3">
              <label class="form-label">{{ 'task.form.titleLabel' | translate }}</label>
              <input
                maxlength="100"
                formControlName="name"
                class="form-control"
                [placeholder]="'task.form.titlePlaceholder' | translate"
              />
              <field-error-component
                [field]="'name'"
                [label]="'task.form.titleErrorLabel' | translate"
                [formGroup]="formGroup"
              />
            </div>
            <div class="col-md-4 mb-3">
              <label class="form-label">{{ 'task.form.taskTypeLabel' | translate }}</label>
              <mat-select formControlName="type" class="form-control">
                @for (item of taskTypes; track $index) {
                <mat-option [value]="item.value">{{ item.label | translate }}</mat-option>
                }
              </mat-select>
            </div>
          </div>
          <div class="row">
            <div class="col-12 mb-3">
              <label class="form-label">{{ 'task.form.descriptionLabel' | translate }}</label>
              <textarea
                class="form-control scroll"
                formControlName="description"
                [placeholder]="'task.form.descriptionPlaceholder' | translate"
                rows="4"
                maxlength="1200"
                style="resize: none"
              ></textarea>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12 col-md-8 mb-3">
              <label class="form-label">{{ 'task.form.assigneeLabel' | translate }}</label>
              <mat-select formControlName="user" class="form-control">
                @for (item of listUser; track $index) {
                  <mat-option [value]="item._id">{{ item.name }}</mat-option>
                }
                <field-error-component
                  [field]="'user'"
                  [label]="'task.form.assigneeErrorLabel' | translate"
                  [formGroup]="formGroup"
                />
              </mat-select>
            </div>
            <div class="col-md-4 mb-3">
              <label class="form-label">{{ 'task.form.priorityLabel' | translate }}</label>
              <mat-select formControlName="priority" class="form-control">
                @for (item of priorities; track $index) {
                <mat-option [value]="item.value">{{ item.label | translate }}</mat-option>
                }
                <field-error-component
                  [field]="'priority'"
                  [label]="'task.form.priorityErrorLabel' | translate"
                  [formGroup]="formGroup"
                />
              </mat-select>
            </div>
          </div>
          <!--
            Link to an opportunity (SPEC-2026-08-crm-pipeline-deals-radar).

            Deal activities and platform tasks are the SAME records (ADR-004), so a task
            created here can belong to a deal, and a next action created from a deal shows
            up here. Optional: a task about a conversation or a contact still has no deal.
          -->
          @if (getModuleCRM()) {
            <div class="row">
              <div class="col-12 mb-3">
                <label class="form-label">{{ 'task.form.cardLabel' | translate }}</label>
                <mat-select formControlName="card" class="form-control">
                  <mat-option [value]="null">{{ 'task.form.cardNone' | translate }}</mat-option>
                  @for (item of listCard; track item._id) {
                    <mat-option [value]="item._id">
                      {{ item.name }}
                      @if (item.funnel?.name) {
                        <small class="text-muted">
                          · {{ item.funnel.name }}@if (item.stage?.name) { · {{ item.stage.name }} }
                        </small>
                      }
                    </mat-option>
                  }
                </mat-select>
                <span class="help-block">
                  <small class="text-muted">{{ 'task.form.cardHelp' | translate }}</small>
                </span>
              </div>
            </div>
          }

          <!--
            The deadline is ONE control: date + time + "sem horário" (E4 RF-04, RF-05), the same
            field the next-action dialog and the conclusion dialog render. Optional here — a
            to-do may have no scheduled moment.
          -->
          <div class="row mb-3">
            <div class="col-12">
              <label class="form-label font-18 mb-2">{{ 'task.form.deadlineLabel' | translate }}</label>
            </div>
            <div class="col-12 col-lg-8">
              <app-schedule-moment-field formControlName="moment" [required]="false" [allowUntimed]="true" idPrefix="taskDeadline" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xs-12 col-lg-5">
      <div class="card">
        <div class="card-body">
          <h5 class="card-title mb-3">{{ 'task.form.attachFile' | translate }}</h5>

          <div
            class="upload-area h-40"
            [ngStyle]="(loadingSpinner$ | async) ? { filter: 'blur(1px)' } : {}"
            (click)="inputFile.click()"
          >
            @if (loadingSpinner$ | async) {
            <loading-component class="loading" diameter="20" />
            } @else {

            <div class="placeholder-content">
              <i
                class="h2 text-muted mdi mdi-cloud-upload-outline text-primary"
              ></i>
              <h5>{{ 'task.form.clickToUpload' | translate }}</h5>
            </div>
            }
            <input
              id="dropzone-file"
              type="file"
              class="d-none"
              (multiple)="(true)"
              #inputFile
              (change)="onAttachmentsSelect($event)"
            />
          </div>
          <div class="dropzone-previews mt-3" id="file-previews"></div>
          <div class="scroll attachment-container">
            @if(attachments.length > 0){
              @for (file of attachments; track $index) {
                <div class="card mt-1 mb-0 shadow-none border">
                  <div class="p-2">
                    <div class="row align-items-center">
                      <div class="col-auto">
                        <img
                          [src]="file.url"
                         class="avatar-sm rounded bg-light" alt=""
                         />
                      </div>
                      <div class="col ps-0">
                        <a class="text-muted fw-bold">
                          {{ file.filename }}
                        </a>
                        <p class="small mb-0">{{ formatBytes(file.size) }}</p>
                      </div>
                      <div class="col-auto">
                        <a
                          href="javascript: void(0);"
                          class="btn btn-link btn-lg text-muted"
                          (click)="removeAttachment($index)"
                        >
                          <i class="ri-close-line text-danger font-24"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              }
            }
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12 gap-2 d-flex justify-content-end pb-4">
      <button class="btn btn-outline-secondary" (click)="goBack()">
        {{ 'task.form.cancelButton' | translate }}
      </button>

      <button
        class="btn btn-success d-flex align-items-center justify-content-center w-70px"
        [disabled]="!formGroup.valid || loading"
        (click)="save()"
      >
        {{ !loading ? (isNew ? ('task.form.saveButton' | translate) : ('task.form.editButton' | translate)) : "" }}
        @if (loading) {
        <mat-spinner [diameter]="15" [color]="'accent'" mode="indeterminate" />
        }
      </button>
    </div>
  </div>
</form>
